export default __webpack_public_path__ + "static/media/piece-en-euro.f04b39d0.svg";